import React, { useContext } from 'react';
import AppContext from './AppContext';
import Step from './Step';

const Signup = () => {
  const context = useContext(AppContext);
  const { component } = context.state.step;

  const StepComponent = Step[component];

  return (
    <>
      <StepComponent />
    </>
  );
};

export default Signup;
